import type { AppConfig } from '@/api/app-config'

// Used before (or without) the app-config response so legal content and
// footers always carry the full, correct supplier identity.
export const FALLBACK_COMPANY: AppConfig['company'] = {
  name: 'Startline',
  legal_name: 'Vincent Rigouts',
  address: 'Meuleveld 17 - 2200 Morkhoven, Belgium',
  vat_number: 'BE0841.244.673',
  kbo_number: '0841.244.673',
}
